import React from 'react';
import PropTypes from 'prop-types';

import TranslationLanguages from 'models/languages/translation_languages';
import TranslateIntoSearchMenuContainerWrapper from './translate_into_search_menu_container_wrapper';

export default function TranslateIntoMenuItem({ onSelect, onClose, lastSelectedLanguage }) {
  const handleSelectLanguage = code => {
    onSelect?.(code);
    onClose?.();
  };

  return (
    <TranslateIntoSearchMenuContainerWrapper
      availableLanguages={TranslationLanguages}
      lastSelectedLanguage={lastSelectedLanguage}
      onSelectLanguage={handleSelectLanguage}
    />
  );
}

TranslateIntoMenuItem.propTypes = {
  lastSelectedLanguage: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};
